/*Se añade link al home en la página de Passwordless del componente Rechange, al no permitir editar el página de forma tradicional*/
document.addEventListener('DOMContentLoaded', function() {
  // Encuentra el elemento con la clase "rc-login"
  var rcLoginElement = document.querySelector('.rc-login');

  // Verifica si el elemento existe antes de agregar el enlace
  if (rcLoginElement) {
    // Crea un elemento de enlace
    var linkElement = document.createElement('a');
    linkElement.href = 'https://madeforliving.com/'; 
    linkElement.textContent = "Don't have a subscription? Return to Store"; 
    
    // Agrega una clase al elemento 'a'
    linkElement.classList.add('goBackHome'); 

    // Inserta el enlace después del elemento con la clase "rc-login"
    rcLoginElement.parentNode.insertBefore(linkElement, rcLoginElement.nextSibling);
  }
});

